import './key.scss';
import { KeyProps } from './key.types';

export const Key = ({ value, children, className }: KeyProps) => {
  return <span className={`cc-key ${className ?? ''}`}>{value || children}</span>;
};
